import { safeStorage } from "@/lib/storage";

type AuthLocation = { pathname: string; search?: string; hash?: string };

/** Accept only routes on this app, never external redirects or auth loops. */
export function safeAuthReturn(value: unknown, fallback = "/eventos"): string {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || value.includes("\\") || Array.from(value).some(char => char.charCodeAt(0) <= 32)) return fallback;
  try {
    const url = new URL(value, "https://tickethall.invalid");
    if (["/entrar", "/auth/callback", "/recuperar-senha"].includes(url.pathname.replace(/\/$/, ""))) return fallback;
    url.searchParams.delete("login");
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}

export function authLocationPath(location: AuthLocation): string {
  return safeAuthReturn(location.pathname + (location.search || "") + (location.hash || ""));
}

export function rememberAuthReturn(path: string) {
  safeStorage.set("auth_redirect_to", safeAuthReturn(path), sessionStorage);
}

export function readAuthReturn(value?: string | null): string {
  return safeAuthReturn(value || safeStorage.get("auth_redirect_to", sessionStorage));
}

export function clearAuthReturn() {
  safeStorage.remove("auth_redirect_to", sessionStorage);
}
